import ValetDataActionTypes from './valetData.types';

export const getFlightIdsStart = () => ({
  type: ValetDataActionTypes.GET_VALET_FLIGHT_IDS_START,
});

export const getFlightIdsSuccess = (flightIds) => ({
  type: ValetDataActionTypes.GET_VALET_FLIGHT_IDS_SUCCESS,
  payload: flightIds,
});

export const getFlightIdsFailure = (error) => ({
  type: ValetDataActionTypes.GET_VALET_FLIGHT_IDS_FAILURE,
  payload: error,
});

export const getFlightTimesStart = () => ({
  type: ValetDataActionTypes.GET_VALET_FLIGHT_TIMES_START,
});

export const getFlightTimesSuccess = (flightTimes) => ({
  type: ValetDataActionTypes.GET_VALET_FLIGHT_TIMES_SUCCESS,
  payload: flightTimes,
});

export const getFlightTimesFailure = (error) => ({
  type: ValetDataActionTypes.GET_VALET_FLIGHT_TIMES_FAILURE,
  payload: error,
});

export const getCustomerDataStart = () => ({
  type: ValetDataActionTypes.GET_VALET_CUSTOMER_DATA_START,
});

export const getCustomerDataSuccess = (customerData) => ({
  type: ValetDataActionTypes.GET_VALET_CUSTOMER_DATA_SUCCESS,
  payload: customerData,
});

export const getCustomerDataFailure = (error) => ({
  type: ValetDataActionTypes.GET_VALET_CUSTOMER_DATA_FAILURE,
  payload: error,
});


export const filterFlightIdsSuccess = (filteredFlightIds) => ({
  type: ValetDataActionTypes.FILTER_VALET_FLIGHTS_SUCCESS,
  payload: filteredFlightIds,
});

export const filterFlightIdsStart = () => ({
  type: ValetDataActionTypes.FILTER_VALET_FLIGHTS_START,

});


export const filterFlightIdsFailure = (error) => ({
  type: ValetDataActionTypes.FILTER_VALET_FLIGHTS_FAILURE,
  payload: error,
});



export const setDof = (dof) => {
  return {
    type: ValetDataActionTypes.SET_VALET_DOF,
    payload: dof,
  };
};

export const setCustomerDataLoading = (status) => ({
  type: ValetDataActionTypes.SET_VALET_CUSTOMER_DATA_LOADING,
  payload: status,
});

export const setFlightIdsLoading = (status) => ({
  type: ValetDataActionTypes.SET_VALET_FLIGHT_ID_LOADING,
  payload: status,
});

export const setSelectedFlightIds = (flightIds) => ({
  type: ValetDataActionTypes.SET_VALET_SELECTED_FLIGHT_IDS,
  payload: flightIds,
});

export const setCustomerCount = (count) => ({
  type: ValetDataActionTypes.SET_VALET_CUSTOMER_COUNT,
  payload: count,
});

export const setFilteredFlightIds = (flightIds) => ({
  type: ValetDataActionTypes.SET_VALET_FILTERED_FLIGHT_IDS,
  payload: flightIds,
});

export const setFilterTimeStart = (start) => ({
  type: ValetDataActionTypes.SET_VALET_FILTER_TIME_START,
  payload: start,
});

export const setFilterTimeEnd = (end) => ({
  type: ValetDataActionTypes.SET_VALET_FILTER_TIME_END,
  payload: end,
});

export const setDestination = (destination) => ({
  type: ValetDataActionTypes.SET_VALET_DESTINATION,
  payload: destination,
});
